import { storage } from '../services/storage.js';
import { createApiConfig } from './api-config.js';
import { getActiveBrokerId } from '../services/broker/broker-registry.js';

const NAV_ICONS = {
  layers: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M10 2L2 6l8 4 8-4-8-4z" stroke="currentColor" stroke-width="1.5" fill="none"/><path d="M2 10l8 4 8-4" stroke="currentColor" stroke-width="1.5" fill="none"/><path d="M2 14l8 4 8-4" stroke="currentColor" stroke-width="1.5" fill="none"/></svg>`,
  chart: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><rect x="3" y="8" width="3" height="9" rx="1" stroke="currentColor" stroke-width="1.5"/><rect x="8.5" y="3" width="3" height="14" rx="1" stroke="currentColor" stroke-width="1.5"/><rect x="14" y="6" width="3" height="11" rx="1" stroke="currentColor" stroke-width="1.5"/></svg>`,
  ladder: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M5 3v14M15 3v14M5 6h10M5 10h10M5 14h10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>`,
  portfolio: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><rect x="3" y="4" width="14" height="12" rx="2" stroke="currentColor" stroke-width="1.5"/><path d="M3 8h14" stroke="currentColor" stroke-width="1.5"/><circle cx="7" cy="12" r="1" fill="currentColor"/><circle cx="10" cy="12" r="1" fill="currentColor"/><circle cx="13" cy="12" r="1" fill="currentColor"/></svg>`,
  scan: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="9" cy="9" r="6" stroke="currentColor" stroke-width="1.5"/><path d="M13.5 13.5L17 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M6 9h6M9 6v6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>`,
  about: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="7" stroke="currentColor" stroke-width="1.5"/><path d="M10 9.2v4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><circle cx="10" cy="6.2" r="0.8" fill="currentColor"/></svg>`
};

export function createSidebar(routes, onNavigate) {
  const el = document.createElement('div');
  el.className = 'sidebar';

  const apiConfig = createApiConfig();

  el.innerHTML = `
    <div class="sidebar-brand">
      <h1>
        <span class="brand-line brand-line-main">Condor</span>
        <span class="brand-line brand-line-subtext">for the</span>
        <span class="brand-line brand-line-main">Common Man</span>
      </h1>
      <div class="brand-sub">Trading Platform</div>
    </div>
    <nav class="sidebar-nav" id="sidebar-nav"></nav>
    <div class="sidebar-footer" id="sidebar-footer">
      <a href="https://dash.tradier.com" target="_blank" rel="noopener" class="sidebar-external-link">
        Tradier Web &rarr;
      </a>
      <div class="sidebar-build-time">${new Date(__BUILD_TIME__).toLocaleString()}</div>
    </div>
  `;

  const nav = el.querySelector('#sidebar-nav');
  const footer = el.querySelector('#sidebar-footer');
  const externalLink = el.querySelector('.sidebar-external-link');

  // Insert API config before the external link
  footer.insertBefore(apiConfig.el, footer.firstChild);

  function updateExternalBrokerLink() {
    const brokerId = getActiveBrokerId();
    if (brokerId === 'ibkr') {
      externalLink.href = 'https://www.interactivebrokers.com/portal/';
      externalLink.textContent = 'IBKR Portal →';
      return;
    }
    externalLink.href = 'https://dash.tradier.com';
    externalLink.textContent = 'Tradier Web →';
  }
  updateExternalBrokerLink();

  routes.forEach(route => {
    const btn = document.createElement('button');
    btn.className = 'sidebar-nav-item';
    btn.dataset.route = route.id;
    btn.innerHTML = `
      <span class="nav-icon">${NAV_ICONS[route.icon] || ''}</span>
      <span>${route.label}</span>
    `;
    btn.addEventListener('click', () => onNavigate(route.id));
    nav.appendChild(btn);
  });

  function setActiveRoute(routeId) {
    nav.querySelectorAll('.sidebar-nav-item').forEach(item => {
      item.classList.toggle('active', item.dataset.route === routeId);
    });
  }

  // Set initial active route
  const initialRoute = window.location.hash.slice(1) || 'options';
  setActiveRoute(initialRoute);

  const unsubscribe = storage.onChange(updateExternalBrokerLink);

  return {
    el,
    setActiveRoute,
    destroy() {
      unsubscribe();
      apiConfig.destroy();
    }
  };
}
